import { lazy } from "react";

const Tds = lazy(() => import("../Component/TDS/Tds"));

// ============================================================
// TDS — DSA COMMISSION TDS MODULE
// ============================================================
const tdsRoutes = [{ path: "/tds", element: <Tds /> }];

export default tdsRoutes;
